import Vue from "vue";

export default Vue.extend({
    data(){
        return {
            editMode : false,
            fieldVal : false
        }
    },
    watch : {
        fieldVal : function(newVal, oldVal) {
            // this.params.node.setDataValue(this.params.colDef.field, newVal ? 1 : 0);
            // this.fieldVal = newVal ? 1 : 0;
            // this.editMode = false;
        },
    },
    created(){
        this.fieldVal = this.params.value;
    },
    methods:{
        editCell(){
            let _self=this;
            _self.editMode=true;
        },
        onCellChanged(){
            let _self=this;
            _self.params.node.setDataValue(_self.params.colDef.field, _self.fieldVal ? 1 : 0);
            _self.editMode = false;
            let params={
                data:_self.params.data,
                rowIndex:_self.params.rowIndex,
                newValue:_self.fieldVal,
                oldValue:_self.params.node.data[_self.params.colDef.field],
                colDef:{field:_self.params.colDef.field}
            };
            params[_self.params.colDef.field]=params.value;
            _self.params.context.componentParent.onCellValueChanged(params);
            //_self.params.context.componentParent
            
        }
    }
});